var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "review-widget-wrapper" },
    [
      _c("h2", [_vm._v(" Would you like to save the details you give us? ")]),
      _c("p", [
        _vm._v(
          "Saving you details will help you finish services faster in the future."
        )
      ]),
      _c("p", [
        _vm._v(
          "If you agree, the following personal information we collected today will be saved securely in your MyServiceNSW account:"
        )
      ]),
      _vm._l(_vm.updatedDetails, function(detail, index) {
        return _c(
          "div",
          { key: index, staticClass: "review-item" },
          [
            _c("div", { staticClass: "update-detail-container" }, [
              _c(
                "label",
                { attrs: { for: "tuo-review-widget-" + detail.name } },
                [
                  _c(
                    "strong",
                    {
                      staticClass: "mr-05",
                      attrs: {
                        "data-test":
                          "checkbox-label-" +
                          ("tuo-review-widget-" + detail.name)
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.sentenceCase(detail.name)) + " ")]
                  ),
                  _c(
                    "span",
                    {
                      attrs: {
                        "data-test":
                          "checkbox-helper-" +
                          ("tuo-review-widget-" + detail.name)
                      }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            typeof detail.value == "object"
                              ? detail.value.displayValue
                              : detail.value
                          ) +
                          " "
                      )
                    ]
                  )
                ]
              )
            ]),
            _c("Badge", { attrs: { value: detail.type } })
          ],
          1
        )
      }),
      _c("PiSecure"),
      _c("p", [
        _vm._v(
          " By selecting 'Save my details', you allow Service NSW to save and use your personal information. "
        )
      ]),
      _c(
        "Accordion",
        { attrs: { header: "Learn how we use your personal information" } },
        [
          _c("div", { staticClass: "accordion-body-subtitle" }, [
            _c("strong", { staticClass: "mr-05" }, [
              _vm._v("Types of information we collect and save:")
            ])
          ]),
          _c("div", { staticClass: "column-layout" }, [
            _c("div", { staticClass: "first-column-information-list" }, [
              _c("div", [_vm._v("First name")]),
              _c("div", [_vm._v("Middle name")]),
              _c("div", [_vm._v("Family name")]),
              _c("div", [_vm._v("Date of birth")])
            ]),
            _c("div", { staticClass: "second-column-information-list" }, [
              _c("div", [_vm._v("Address")]),
              _c("div", [_vm._v("Mobile number")]),
              _c("div", [_vm._v("Driver licence card details")]),
              _c("div", [_vm._v("Medicare card details")])
            ])
          ]),
          _c("div", { staticClass: "accordion-body-subtitle" }, [
            _c("strong", { staticClass: "mr-05 accordion-body-subtitle" }, [
              _vm._v("How we user your information")
            ])
          ]),
          _c("div", [
            _vm._v(
              "We pre-fill your personal details in forms that you complete online."
            )
          ]),
          _c("div", { staticClass: "accordion-body-subtitle" }, [
            _c("strong", { staticClass: "mr-05 accordion-body-subtitle" }, [
              _vm._v("Services that may use your information")
            ])
          ]),
          _c("ul", [
            _c("li", [_vm._v("Active Kids")]),
            _c("li", [_vm._v("Creative Kids")]),
            _c("li", [_vm._v("Seniors Energy Rebate")]),
            _c("li", [_vm._v("Energy Switch")])
          ]),
          _c("p", [
            _vm._v(" Our "),
            _c(
              "a",
              {
                staticClass: "is-internal",
                attrs: {
                  id: "privacy-link",
                  href: "https://www.service.nsw.gov.au/privacy",
                  target: "_blank"
                },
                on: {
                  click: function($event) {
                    return _vm.triggerGA("Privacy Link", "Click")
                  }
                }
              },
              [_vm._v(" privacy statement ")]
            ),
            _vm._v(" explains how we collect and use information. ")
          ])
        ]
      ),
      _c(
        "Button",
        {
          attrs: {
            secondary: "",
            "data-test": "save-update",
            disabled: _vm.saveDisabled
          },
          on: { click: _vm.saveCustomerDetails }
        },
        [_vm._v(" Save my details ")]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }